
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/hizmetler', label: 'Hizmetler' },
    { path: '/hakkimizda', label: 'Hakkımızda' },
    { path: '/iletisim', label: 'İletişim' },
  ];

  const handleCall = () => {
    window.location.href = 'tel:+905422671171';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy shadow-md">
      <nav className="px-0">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo - Sol Köşe */}
          <Link to="/" className="flex items-center group pl-0">
            <img
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/b1acd31a7a45ce877b97408cf0eb917c.png"
              alt="LH Global Pass Logo"
              className="h-20 w-auto lg:h-24 transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10 flex-1 justify-center">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 hover:text-gold whitespace-nowrap ${
                  location.pathname === link.path ? 'text-gold' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Right Section */}
          <div className="hidden lg:flex items-center gap-4 pr-8">
            <a
              href="tel:+905422671171"
              className="text-sm font-medium text-white transition-colors duration-300 flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              <span className="whitespace-nowrap">+90 542 267 11 71</span>
            </a>
            <button
              onClick={handleCall}
              className="bg-gold hover:bg-gold-dark text-navy px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 hover:shadow-lg whitespace-nowrap"
            >
              Randevu Al
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-2xl text-white transition-colors duration-300 pr-4"
            aria-label="Menu"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 text-sm font-medium transition-colors duration-300 hover:bg-gray-50 ${
                  location.pathname === link.path ? 'text-gold' : 'text-navy'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-4 space-y-3">
              <a
                href="tel:+905422671171"
                className="block text-center bg-navy text-white px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                +90 542 267 11 71
              </a>
              <button
                onClick={handleCall}
                className="block w-full bg-gold text-navy px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap"
              >
                Randevu Al
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
